module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Home-heart-390f37bee3b6de20cadd81b286a12c89.svg";